import React, { useState } from 'react';
import styled from '@emotion/native';
import useExploreStore from '@/stores/useExploreStore';
import { Label, Subtitle, Title } from './styledComponents';
import Dropdown from '@/shared/components/Dropdown';
import ScrollableView from '@/shared/components/ScrollableView';
import { borderColor, placeholder } from '@/shared/styles/colors';
import { REASON_OPTIONS } from './shared/constants';

const RequestDetails: React.FC = () => {
  const { booking, setBooking } = useExploreStore();

  const [isReasonMenuVisible, setIsReasonMenuVisible] = useState(false);

  return (
    <Container>
      <Content contentContainerStyle={{ alignItems: 'center' }}>
        <TitleContainer>
          <Title>What Should Your Stylist Know?</Title>
          <Subtitle>Share any details to tailor your session.</Subtitle>
        </TitleContainer>

        <Label marginBottom={12} style={{ width: '100%' }}>
          What&apos;s the reason for your session?
        </Label>
        <Dropdown
          eyebrowText="Reason"
          options={REASON_OPTIONS}
          selectedOption={booking.reason}
          onSelect={(option) => setBooking({ reason: option.value as string })}
          isVisible={isReasonMenuVisible}
          setIsVisible={setIsReasonMenuVisible}
          useTitleCase={true}
        />

        <InputContainer>
          <Label marginBottom={12}>
            Anything additional you&apos;d like your stylist to know? (optional)
          </Label>
          <TextArea
            multiline
            placeholder="Enter additional information"
            placeholderTextColor={placeholder}
            value={booking.additionalDetails}
            onChangeText={(text) => setBooking({ additionalDetails: text })}
          />
        </InputContainer>
      </Content>
    </Container>
  );
};

const Container = styled.View({
  flex: 1,
});

const Content = styled(ScrollableView)({
  flex: 1,
  paddingHorizontal: 32,
  width: '100%',
});

const TitleContainer = styled.View({
  marginBottom: 32,
});

const InputContainer = styled.View({
  marginBottom: 24,
  width: '100%',
});

const TextArea = styled.TextInput({
  backgroundColor: 'white',
  padding: 16,
  borderRadius: 9,
  borderWidth: 1,
  borderColor: borderColor,
  height: 125,
  textAlignVertical: 'top',
  maxWidth: 326,
});

export default RequestDetails;
